import React, { useContext } from 'react';
import { ButtonStyled } from './Styled';
import { context } from '../../../context';
import { withFilters } from '../../../hocs/withFilters';

const ButtonClean = (props: { cleanFilters: () => void; bold?: boolean }) => {
  const { cleanFilters, bold } = props;
  const { queryParam, dispatchMetrics } = useContext<any>(context);
  const onClick = () => {
    cleanFilters();
    dispatchMetrics('event:track', {
      category: 'avaliacao-pdp',
      action: 'limpar-todos-filtros',
    });
  };

  if (!queryParam?.rating?.length && !queryParam?.badges) {
    return <></>;
  }

  return (
    <ButtonStyled bold={bold} className="filter product-review-button-clean-filter" onClick={onClick}>
      limpar todos
    </ButtonStyled>
  );
};
const ButtonCleanFilter = withFilters(ButtonClean);
export default ButtonCleanFilter;
export { ButtonCleanFilter, ButtonClean };
